@use '../../../styling/colors.scss' as *;

.EmptyState {
  padding: 12px 16px 7px;
  display: flex;
  flex-direction: column;
  row-gap: 8px;
  align-items: center;
  overflow: hidden;
}
